/* eslint-disable */
export enum matchFieldsLocalisationKeys {
  RESERVATION_RECEIVED = 'RESERVATION_RECEIVED',
  MATCH_YOUR_DATA = 'MATCH_YOUR_DATA',
  ISSUES = 'ISSUES',
  COLUMN = 'COLUMN',
  ASSIGNED_FIELD = 'ASSIGNED_FIELD',
  SAMPLE_VALUE = 'SAMPLE_VALUE',
  CHOOSE_FIELD = 'CHOOSE_FIELD',
  RESOLVE_OUTSTANDING_ISSUES = 'RESOLVE_OUTSTANDING_ISSUES',
  PLEASE_MATCH_DATA = 'PLEASE_MATCH_DATA',
  CHOOSE_TIME_FORMAT = 'CHOOSE_TIME_FORMAT',
  CHOOSE_DATE_FORMAT = 'CHOOSE_DATE_FORMAT',
  ALLOWED_SEPARATORS_FOR_DATE_FORMAT = 'ALLOWED_SEPARATORS_FOR_DATE_FORMAT',
  BOOKING_ID_EMPTY = 'BOOKING_ID_EMPTY',
  TIMEZONE_EMPTY = 'TIMEZONE_EMPTY',
  TIME_START_DATE_START_REQUIRED = 'TIME_START_DATE_START_REQUIRED',
  TIME_END_DATE_END_REQUIRED = 'TIME_END_DATE_END_REQUIRED',
  ONE_VERSION_TIME_AND_DATE = 'ONE_VERSION_TIME_AND_DATE',
  MORE_THAN_START = 'MORE_THAN_START',
  NOT_VALID_STRING = 'NOT_VALID_STRING',
  NOT_VALID_TIMEZONE = 'NOT_VALID_TIMEZONE',
  SELECT_TZ = 'SELECT_TZ',
  SELECT_TZ_DIALOG = 'SELECT_TZ_DIALOG',
  YOUR_TIMEZONE = 'YOUR_TIMEZONE',
  USE_CURRENT_TIMEZONE = 'USE_CURRENT_TIMEZONE',
  NOT_VALID_TIME_COLUMNS = 'NOT_VALID_TIME_COLUMNS',
  SAVE = 'SAVE',
  CLEAR = 'CLEAR',
  CANCEL = 'CANCEL',
  RESOLVE_ERRORS = 'RESOLVE_ERRORS'
}

export const enMatchFieldsLocalisationMessages = {
  [matchFieldsLocalisationKeys.RESERVATION_RECEIVED]: `Reservation received`,
  [matchFieldsLocalisationKeys.MATCH_YOUR_DATA]: `Next, match your data fields to ours.`,
  [matchFieldsLocalisationKeys.ISSUES]: `Issues`,
  [matchFieldsLocalisationKeys.COLUMN]: `Column`,
  [matchFieldsLocalisationKeys.ASSIGNED_FIELD]: `Assigned Field`,
  [matchFieldsLocalisationKeys.SAMPLE_VALUE]: `Sample Value`,
  [matchFieldsLocalisationKeys.CHOOSE_FIELD]: `Choose field`,
  [matchFieldsLocalisationKeys.RESOLVE_OUTSTANDING_ISSUES]: `Please resolve outstanding issues before continuing`,
  [matchFieldsLocalisationKeys.PLEASE_MATCH_DATA]: `Please match your data fields`,
  [matchFieldsLocalisationKeys.CHOOSE_TIME_FORMAT]: `Select the time format used in your file`,
  [matchFieldsLocalisationKeys.CHOOSE_DATE_FORMAT]: `Select the date format used in your file`,
  [matchFieldsLocalisationKeys.ALLOWED_SEPARATORS_FOR_DATE_FORMAT]: `Allowed separators: -, /, ., (space)`,
  [matchFieldsLocalisationKeys.SELECT_TZ]: `Select your timezone here `,
  [matchFieldsLocalisationKeys.SELECT_TZ_DIALOG]: `Select Timezone`,
  [matchFieldsLocalisationKeys.YOUR_TIMEZONE]: `Your current timezone is`,
  [matchFieldsLocalisationKeys.USE_CURRENT_TIMEZONE]: `Use current timezone`,
  [matchFieldsLocalisationKeys.SAVE]: `Save`,
  [matchFieldsLocalisationKeys.CLEAR]: `Clear`,
  [matchFieldsLocalisationKeys.CANCEL]: `Cancel`,
  [matchFieldsLocalisationKeys.RESOLVE_ERRORS]: `Please resolve all errors`,
  [matchFieldsLocalisationKeys.BOOKING_ID_EMPTY]: `You have not included a booking ID.`,
  [matchFieldsLocalisationKeys.TIMEZONE_EMPTY]: `You haven't included a timezone in your data.`,
  [matchFieldsLocalisationKeys.TIME_START_DATE_START_REQUIRED]: `You must include the start date & time of your reservations.`,
  [matchFieldsLocalisationKeys.TIME_END_DATE_END_REQUIRED]: `You must include the end date & time of your reservations.`,
  [matchFieldsLocalisationKeys.ONE_VERSION_TIME_AND_DATE]: `Date & Time can't be combined with the Timestamp option.`,
  [matchFieldsLocalisationKeys.MORE_THAN_START]: `The start date can't be after the end date.`,
  [matchFieldsLocalisationKeys.NOT_VALID_STRING]: `The value used in this field is invalid or too long.`,
  [matchFieldsLocalisationKeys.NOT_VALID_TIMEZONE]: `The value in Timezone is not a valid timezone. See the documentation for supported formats.`,
  [matchFieldsLocalisationKeys.NOT_VALID_TIME_COLUMNS]: `The values in Time are not a valid time format.`
}
